import { ReportPage } from './ReportPage';

export function AvailableCapacity() {
  return <ReportPage reportName="Available capacity" />;
}
